<!--<div class="card card-box mb-5">-->
<!--  <div class="card-header py-3">-->
<!--    <div class="card-header&#45;&#45;title font-size-lg">-->
<!--      <b><i class="fas fa-cog"></i> Galary </b>-->
<!--    </div>-->
<!--    <div class="card-header&#45;&#45;actions">-->
<!--            <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="lgModal.show()">-->
<!--                      <span class="btn-wrapper&#45;&#45;icon">-->
<!--                          <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
<!--                      </span>-->
<!--              <span class="btn-wrapper&#45;&#45;label">-->
<!--                          New Image-->
<!--                      </span>-->
<!--            </button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-between px-4 py-3">-->
<!--    <div class="search-wrapper">-->
<!--          <span class="icon-wrapper text-black">-->
<!--            <fa-icon [icon]="['fas', 'search']"></fa-icon>-->
<!--          </span>-->
<!--      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="divider"></div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table table-hover text-nowrap mb-0">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        &lt;!&ndash;        <th class="bg-white text-center">ID</th>&ndash;&gt;-->
<!--        <th class="bg-white text-center">ID</th>-->
<!--        <th class="bg-white text-center">FILE NAME</th>-->
<!--        <th class="bg-white text-center">TYPE</th>-->
<!--        <th class="bg-white text-center">VIEW</th>-->
<!--        <th class="bg-white text-center">ACTIONS</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let gal of galary">-->
<!--        &lt;!&ndash;        <td class="font-weight-bold text-center">&ndash;&gt;-->
<!--        &lt;!&ndash;         {{pac.id}}&ndash;&gt;-->
<!--        &lt;!&ndash;        </td>&ndash;&gt;-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{gal.id}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{gal.fileName}}-->
<!--        </td>-->
<!--        <td class="text-center">-->
<!--          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">-->
<!--            {{gal.fileType}}-->
<!--          </span>-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            <button  type="button" class="btn btn-warning" (click)="view(viewModal,gal.id)">-->
<!--              <i class="fas fa-eye"></i>-->
<!--            </button>-->
<!--          </div>-->
<!--        </td>-->

<!--        <td class="text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            &lt;!&ndash;            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>&ndash;&gt;-->
<!--            <button type="button" class="btn btn-danger" (click)="openModal(errorModal,gal.id)" ><i class="fas fa-times-circle"></i></button>-->

<!--          </div>-->
<!--        </td>-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->


<!--  </div>-->
<!--  <div class="card-footer py-3 d-flex justify-content-between">-->

<!--  </div>-->
<!--</div>-->


<ng-template #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to CANCEL this entry?</h4>
    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
    <div class="pt-4">
      <button (click)="declineCancel()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmCancel()" class="btn btn-pill btn-danger mx-1" type="button">
                <span class="btn-wrapper--label">
                    Delete
                </span>
      </button>
    </div>
  </div>
</ng-template>


<!--<div bsModal #lgModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">Large modal</h6>-->
<!--        <button type="button" class="close" (click)="lgModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->

<!--        <div class="row">-->
<!--          <div class="col-xl-6">-->
<!--            <div class="card card-box text-center mb-5 p-4">-->
<!--              <h5 class="display-4 font-weight-bold">Upload image</h5>-->
<!--              <p class="text-black-50 mb-4">Use the file field below to upload a new image to test the crop functionality.</p>-->

<!--              <div class="rounded-sm bg-light p-3">-->
<!--                <div class="input-group text-left mb-0">-->
<!--                  <div class="custom-file">-->
<!--                    <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01">-->
<!--                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="divider my-4"></div>-->

<!--              <h5 class="display-4 font-weight-bold">Image modifiers</h5>-->
<!--              <p class="text-black-50">Use the buttons below to modify the behaviour of the cropped image.</p>-->

<!--              <div>-->
<!--                <button (click)="rotateLeft()" class="btn btn-warning btn-sm m-2">Rotate left</button>-->
<!--                <button (click)="rotateRight()" class="btn btn-warning btn-sm m-2">Rotate right</button>-->
<!--                <button (click)="flipHorizontal()" class="btn btn-warning btn-sm m-2">Flip horizontal</button>-->
<!--                <button (click)="flipVertical()" class="btn btn-warning btn-sm m-2">Flip vertical</button>-->
<!--              </div>-->

<!--              <div class="divider my-4"></div>-->

<!--              <h5 [hidden]="showCropper" class="display-4 mb-3 font-weight-bold">Result</h5>-->

<!--              <div [hidden]="showCropper">-->
<!--                <img [src]="croppedImage" class="rounded-sm"/>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-xl-6">-->
<!--            <div class="card card-box mb-5 p-4">-->
<!--              <h5 [hidden]="!showCropper" class="display-4 mb-3 font-weight-bold">Cropped image</h5>-->

<!--              <image-cropper-->
<!--                class="rounded-sm"-->
<!--                (imageCropped)="imageCropped($event)"-->
<!--                (imageLoaded)="imageLoaded()"-->
<!--                [alignImage]="'center'"-->
<!--                [aspectRatio]="4 / 3"-->
<!--                [cropperMinWidth]="340"-->
<!--                [imageChangedEvent]="imageChangedEvent"-->
<!--                [maintainAspectRatio]="true"-->
<!--                [onlyScaleDown]="true"-->
<!--                [resizeToWidth]="340"-->
<!--                [roundCropper]="false"-->
<!--                [style.display]="showCropper ? null : 'none'"-->
<!--                format="png"-->
<!--                outputType="file"-->
<!--              ></image-cropper>-->
<!--              <div class="font-size-lg text-center text-danger p-5" [hidden]="showCropper">-->
<!--                <h5 class="display-4 text-black mb-3 font-weight-bold">Cropped image</h5>-->
<!--                To see the image cropper in action, upload an image using the left form input.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="lgModal.hide()">Close</button>-->
<!--        <button type="button" class="btn btn-success ml-auto ladda-button"  data-style="slide-up"-->
<!--                [ladda]="isLoading" (click)="upload()">Save changes</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<!--<div bsModal #viewModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">View</h6>-->
<!--        <button type="button" class="close" (click)="viewModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->

<!--        <img style="width: 100%" src="data:image/png;base64,{{img}}" alt="">-->

<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="viewModal.hide()">Close</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<notifier-container></notifier-container>

<h4><b>Gallery</b></h4>
<p class="text-muted">upload pictures to the gallery</p>
<hr>
<div class="row">
  <div class="col-12 m-3">
    <ngx-dropzone (change)="onSelect($event)">
      <ngx-dropzone-label>Drop!</ngx-dropzone-label>
      <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
      </ngx-dropzone-preview>
    </ngx-dropzone>
  </div>
  <div class="col-12 text-right">

    <button type="button" class="btn btn-success ml-auto ladda-button" [disabled]="files.length==0"
            data-style="slide-up"
            [ladda]="isLoading" (click)="upload()">Upload
    </button>
  </div>

  <div class="col-12 m-3">
    <div class="row">
      <div class="col-xl-4 col-lg-6" *ngFor="let gal of galary">
        <div class="card mb-5">
          <img alt="..." class="card-img-top" style="height: 16rem;" src="{{gal.url}}"/>
          <div class="card-body">
            <div class="row">
              <div class="col-10">
                <h5 class="card-title font-weight-bold font-size-lg"> {{gal.fileName | slice:0:100}}</h5>
              </div>
              <div class="col-1">
                <i class="fas fa-times-circle text-danger" style="cursor: pointer" (click)="openModal(errorModal,gal.id)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer py-3 d-flex justify-content-center">
      <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="getAllImages($event.page)"
                  class="pagination-icons pagination-warning"></pagination>
    </div>
  </div>


</div>
